import ROUTE_NAMES from '../../../routes/routeNames';
import { MENU_ICONS } from './menuIcons';
import type { MenuItem } from '../types/MenuItem';
import { allPermissions } from '../../../../scripts/test/mocks/allPermissions';

export const MENU_ITEMS: MenuItem[] = [
    {
        routeName: ROUTE_NAMES.HOME,
        routeNamesToHighlight: [ROUTE_NAMES.HOME],
        inlinedSvg: MENU_ICONS.HomeIcon,
        text: 'Home',
        permissions: [
            allPermissions.generalHome,
        ],
    },
    {
        routeName: ROUTE_NAMES.OBSERVE_MAIN,
        routeNamesToHighlight: [ROUTE_NAMES.OBSERVE_MAIN],
        inlinedSvg: MENU_ICONS.ObserveIcon,
        text: 'Observe',
        permissions: [
            allPermissions.monitoring,
        ],
    },
    {
        routeName: ROUTE_NAMES.REVIEW_MAIN,
        routeNamesToHighlight: [
            ROUTE_NAMES.REVIEW_MAIN,
            ROUTE_NAMES.REVIEW_LIST,
            ROUTE_NAMES.REVIEW_THUMBNAILS,
            ROUTE_NAMES.REVIEW_RECORD_SHOW,
            ROUTE_NAMES.REVIEW_RECORD_SHARED_SHOW,
            ROUTE_NAMES.REVIEW_PLAYLIST_VIEW,
        ],
        inlinedSvg: MENU_ICONS.ReviewIcon,
        text: 'Review',
        permissions: [
            allPermissions.review,
        ],
    },
    {
        routeName: ROUTE_NAMES.SCHEDULE_MAIN,
        routeNamesToHighlight: [ROUTE_NAMES.SCHEDULE_MAIN],
        inlinedSvg: MENU_ICONS.ScheduleIcon,
        text: 'Schedule',
        permissions: [
            allPermissions.schedule,
        ],
    },
    {
        routeName: ROUTE_NAMES.REPORT_ROOT,
        routeNamesToHighlight: [
            ROUTE_NAMES.REPORT_ROOT,
            ROUTE_NAMES.REPORT_VIEW,
        ],
        inlinedSvg: MENU_ICONS.ReportsIcon,
        text: 'Reports',
        permissions: [
            allPermissions.reports,
        ],
    },
    {
        routeName: ROUTE_NAMES.ADMIN_MAIN,
        routeNamesToHighlight: [ROUTE_NAMES.ADMIN_MAIN],
        inlinedSvg: MENU_ICONS.SettingsIcon,
        text: 'Settings',
        permissions: [
            allPermissions.admin,
            allPermissions.adminGeneral,
        ],
    },
];
